export const environment = {
  production: true,
  apiAuthority: 'https://api.fusionlex.com/api/v1',
  publicEndpoints: {
    login: '/sso/login',
    signUp: '/sso/sign-up',
    validateSetupToken: '/sso/validate-setup-token',
    setupPassword: '/sso/setup-password'
  },
  privateEndpoints: {
    logout: '/sso/logout',
    processingUploadInit: '/processing/upload/init',
    processingUploadPartUrl:'/processing/upload/part-url',
    processingUploadComplete:'/processing/upload/complete',
    processingUploadAbort:'/processing/upload/abort',
    processingVoice: '/processing/voice',
    processingVoiceJob: '/processing/jobs/{jobId}',
    processingVoiceJobs: '/processing/jobs',
    processingVoiceJobSpeakers: '/processing/jobs/{jobId}/speakers',
    processingVoiceJobDashboard: '/processing/jobs/{jobId}/dashboard',
    processingVoiceJobInsights: '/processing/jobs/{jobId}/insights',
    insights: '/bedrock/insights',
    dashboardInsights: '/bedrock/jobs/{jobId}/dashboard-insight',
    validateAccount: '/sso/validate-account',
    pendingAccounts: '/sso/pending-accounts'
  },
  firebase: {
    apiKey: '********************************',
    authDomain: '********************************',
    projectId: '********************************',
    storageBucket: '********************************',
    messagingSenderId: '********************************',
    appId: '********************************',
    measurementId: '********************************',
  },
};

